'use strict';

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
};

exports["default"] = function (props, value, position) {
  if (position) return position <= props.trackLength;
  var min = props.min,
      max = props.max,
      step = props.step;

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    // if Array
    return value[1] - value[0] >= step && value[0] >= min && value[1] <= max;
  } else {
    // TODO : is step needed here ?
    return value >= min && value <= max;
  }
};